<script setup>
const { normalizeUrl } = useNormalizeUrl();

const props = defineProps({
  text: Object,
  initialUrl: {
    type: String,
    default: "",
  },
  initialEmail: {
    type: String,
    default: "",
  },
  errors: {
    type: Object,
    default: () => ({ url: "", email: "" }),
  },
});

const emit = defineEmits(["next-block", "update-form"]);

const url = ref(props.initialUrl);
const email = ref(props.initialEmail);

// Handle form submission and move to next block
const submitForm = () => {
  const fixedUrl = normalizeUrl(url.value);

  // Emit the form data to the parent for validation
  emit("update-form", fixedUrl, email.value);

  // Trigger next block navigation in parent
  emit("next-block");
};
</script>

<template>
  <div class="">
    <!-- Text -->
    <div v-if="text?.content" class="">
      <div v-html="text?.content" class="prose mb-lg"></div>
    </div>

    <!-- Website URL -->
    <div class="mb-md">
      <label class="inline-block font-bold pb-sm">Webpagina</label>
      <input
        v-model="url"
        class="bg-input-black px-md py-xs outline-none text-white border-2 border-transparent !border-2-b !border-b-white transition-colors duration-100 border-solid border-gray-light focus:border-2 focus:mr-[-1px] focus:!border-red w-full"
        :class="{ 'border-red': errors.url }"
        name="url"
        placeholder="https://www.website.nl"
        type="text"
      />
      <p v-if="errors.url" class="text-red text-sm mt-1">{{ errors.url }}</p>
    </div>

    <!-- E-mail -->
    <div class="mb-xl">
      <label class="inline-block font-bold pb-sm">E-mail</label>
      <input
        v-model="email"
        class="bg-input-black px-md py-xs outline-none text-white border-2 border-transparent !border-2-b !border-b-white transition-colors duration-100 border-solid border-gray-light focus:border-2 focus:mr-[-1px] focus:!border-red w-full"
        :class="{ 'border-red': errors.email }"
        name="email"
        placeholder="naam@website.nl"
        type="text"
      />
      <p v-if="errors.email" class="text-red text-sm mt-1">
        {{ errors.email }}
      </p>
    </div>

    <!-- Button -->
    <div>
      <button @click="submitForm" class="btn">Start scan</button>
    </div>
  </div>
</template>
